<template>
  <div class="card-wrapper">
    <div class="cart-card" @click="onCardClick">
      <div class="cart-card-title">
        <div v-if="info.type === 0">
        <div class="title-text" style="color:#cc2a29" v-if="(info.name).indexOf('良')  === 0">{{ info.name }}</div>
        <div class="title-text" v-else>{{ info.name }}</div>
        </div>
        <div v-if="info.type === 1">
         <div class="title-text" style="color:#cc2a29" v-if="(info.name).indexOf('良')  === 0">{{ info.name }}(彩虹班车)</div>
        <div class="title-text" v-else>{{ info.name }}(彩虹班车)</div>
        </div>
        
        <div class="title-price">￥{{ price || "0.00" }}</div>
      </div>
      <div class="cart-card-content">
        <div class="card-left">
          <div class="car-start-position">
           <!-- <div class="car-time">{{ info.origin_time }}</div>-->
            <div class="car-start-site">
              <div class="car-label upper">上</div>
              <div class="site-text">{{ info.origin_address }} {{ info.origin_time }}</div>
            </div>
          </div>
          <div class="car-end-position">
            <!--<div class="car-time">{{ info.end_time }}</div>-->
            <div class="car-end-site">
              <div class="car-label down">下</div>
              <div class="site-text">{{ info.end_address }}</div>
            </div>
          </div>
        </div>
        <van-button plain type="primary" class="main-button" v-if="info.type === 0" @click="onClickChoose">补票</van-button>
        <van-button plain type="primary" class="main-button" v-if="info.type === 1" @click="onCardClick">补票</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { Dialog, Toast } from 'vant';
import Order from '@/apis/Order';
export default {
  name: 'CartCard',
  props: ['info'],
  data() {
    return {
      loading: false,
	  };
  },
  computed: {
    isStudent() {
      return this.$store.getters['auth/isStudent'];
    },
    userId() {
      return this.$store.getters['auth/userId'];
    },
    price() {
      // if (this.userId) {
      //   const firstLetter = this.userId.slice(0, 1);
      //   const studentStartLetter = ['1', '2', '3', '5'];
      //   if (studentStartLetter.indexOf(firstLetter) > -1) {
      //     return this.info?.student_ticket_price;
      //   }
      //   return this.info.teacher_ticket_price;
      // }
      // return '';
      // if (this.isStudent) {
      //   return this.info?.student_ticket_price;
      // }
      return this.isStudent ? this.info?.student_ticket_price : this.info?.teacher_ticket_price;
    },
    message() {
      return this.isStudent ? '发车前1小时开始预约' : '发车前24小时开始预约';
    },
  },
  mounted() {
  },
  methods: {
    onCardClick() {

     if(this.info.type === 1){
          Toast.fail('请到微信公众号关注彩虹巴士预约');
          return ;
     }else{
        this.$router.push({
              path: '/maprepair',
              query: {
                id: this.info?.id,
                shuttleType: this.info?.shuttle_type,
                serviceTime: this.info?.service_time,
                originTime: this.info?.origin_time,
                price: this.price,
              },
            });
     }

     
    },
    onClickChoose(e) {
      e.stopPropagation();
      e.preventDefault();
      // this.$router.push({
      //   path: '/choose',
      //   query: {
      //     id: this.info?.id,
      //     shuttleType: this.info?.shuttle_type,
      //     serviceTime: this.info?.service_time,
      //     originTime: this.info?.origin_time,
      //     price: this.price,
      //   },
      // });
	  Dialog.alert({
	    title: '提示',
	    message: '补票成功后不可退票，确定继续？',
	    showCancelButton: true,
	  }).then(() => {
	    this.repairHeld();
	  });
			
    },
	async repairHeld(){
		this.loading = true;
		const ordering = Toast.loading({
		  message: '补票中...',
		  forbidClick: true,
		});
		const data = {
		  id: this.info?.id,
		  date: moment(new Date()).format('YYYY-MM-DD'),
		  seat_number: '',
		};
		const res = await Order.createBpOrder(data);
		if (Number(res.code) === 1) {
		 Toast.success('下单成功');
		      setTimeout(() => {
		   this.$router.replace({ path: '/repair' });
		  
		 }, 2000);
		} else {
		  ordering.clear();
		  this.loading = false;
		  const message = res?.message || '下单失败';
		  Toast.fail(message);
		}
	}
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variable.scss";
@import "~@/assets/styles/mixins.scss";

.card-wrapper {
}

.cart-card {
  padding: 0 10px;
  background: #fff;
}

.cart-card-title {
  font-weight: bold;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f3f3f3;
  height: 44px;
  line-height: 44px;
  .title-text {
    color: #000;
  }
  .title-price {
    color: $brand-color;
  }
}

.cart-card-content {
  position: relative;
  margin-bottom: 15px;
  padding: 15px 0;
}

.main-button {
  height: 30px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  border-color: $brand-color;
  color: $brand-color!important;
  border-radius: 0.28rem;
}

.car-start-position, .car-end-position {
  display: flex;
  align-items: center;
  height: 30px;
  line-height: 30px;
  color: #686868;
}

.car-end-site, .car-start-site {
  display: flex;
  align-items: center;
}

.car-time {
  color: #5d5d5d;
  margin-right: 10px;
}

.car-label {
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  color: #fff;
  font-size: 10px;
  text-align: center;
  transform: scale(0.7);
  position: relative;
  &.upper{
    background: $start-site-color;
  }
  &.down {
    background: $stop-site-color;
  }
}

.site-text {
  margin-left: 10px;
  @include text-ellipsis-2(1);
}
</style>
